define('view/controller/booking/result/BookingResultItemView',['require','__original__/BookingResultItemView','lib/ExtendClassProperty','lib/view/ModalRegion','pwa/plugin/tickets/view/TicketsItemDialogView'],function (require) {

    var ParentBookingResultItemView = require('__original__/BookingResultItemView');
    var extendProperty = require('lib/ExtendClassProperty');
    var ModalRegion = require('lib/view/ModalRegion');
    var TicketsItemDialogView = require('pwa/plugin/tickets/view/TicketsItemDialogView');

    /**
     * Booking information item in result view
     *
     * @class BookingResultItemView
     */
    return ParentBookingResultItemView.extend({

        ui: extendProperty('ui', {
            showTicket: '.sb_show_ticket'
        }),

        events: extendProperty('events', {
            'click @ui.showTicket': 'showTicketDialog'
        }),

        showTicketDialog: function () {
            var region = new ModalRegion();

            var view = new TicketsItemDialogView({
                ticketCode: this.model.get('ticket'),
                serviceName: this.model.get('service').name,
                startDate: this.model.get('start_date'),
                startTime: this.model.get('start_time'),
                endTime: this.model.get('end_time'),
                providerName: this.model.get('provider').name,
            });

            region.show(view);
        },
    });

});
